export type HealthDeparmentNumber = "374001539" | "374001505";
export const HealthDeparmentNumberLookup: {
  [key: string]: string;
} = {
  "374001539": "Scheibenberg",
  "374001505": "Zwickau",
};
